import { FC } from 'react'
import { IJobBase } from '@/types'
import styles from './index.module.scss'

type Props = {
  job: IJobBase
}

export const JobTitle: FC<Props> = ({ job }) => {
  return (
    <div className='container'>
      <div className={styles.container}>
        <p className={styles.title}>{job?.title}</p>
      </div>
    </div>
  )
}
